import { Activity } from './activity';
export class ContextActivities {
    category;
    parent;
    grouping;
    other;
    constructor(cfg = {}) {
        const { category, parent, grouping, other } = cfg;
        const make_single_activity = (prop) => {
            if (prop instanceof Activity) {
                return prop;
            }
            if (typeof prop === 'string') {
                return new Activity({ id: prop });
            }
            return new Activity(prop);
        };
        const make_activities = (prop) => {
            if (prop === undefined) {
                return undefined;
            }
            if (Array.isArray(prop)) {
                return prop.map((v) => make_single_activity(v));
            }
            return [make_single_activity(prop)];
        };
        this.category = make_activities(category);
        this.parent = make_activities(parent);
        this.grouping = make_activities(grouping);
        this.other = make_activities(other);
    }
    asVersion(version = '1.0.3') {
        const { category, parent, grouping, other } = this;
        const result = {
            category: category && category.map((v) => v.asVersion(version)),
            parent: parent && parent.map((v) => v.asVersion(version)),
            grouping: grouping && grouping.map((v) => v.asVersion(version)),
            other: other && other.map((v) => v.asVersion(version))
        };
        return result;
    }
    static fromJSON(contextActivitiesJSON) {
        const _contextActivities = JSON.parse(contextActivitiesJSON);
        return new ContextActivities(_contextActivities);
    }
}
